import React from "react";
//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { CashReconciliationCreateFormContainer } from "components/cashReconciliation";
//#endregion

function useCreateCashReconciliationDialog(onCreateSuccess?: () => void): DialogProps {
  return {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SubmitDailyTakings),
    titleIcon: IconDefinitionConstants.WCalculator,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
        successMessage: TranslationKeys.CashReconciliation.CreatedDailyTaking,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <CashReconciliationCreateFormContainer />,
    maxWidth: "md",
    onSubmit: onCreateSuccess,
  };
}

export default useCreateCashReconciliationDialog;
